var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditFollow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19686"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 11282"
}, /*#__PURE__*/React.createElement("path", {
  d: "m17.983 17.592-2.549 2.549",
  "data-name": "Path 5519"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.983 20.141-2.549-2.549",
  "data-name": "Path 5520"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.034 11.063a4.018 4.018 0 1 1 .3 0 1.6 1.6 0 0 0-.3 0",
  "data-name": "Path 5521"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.187 20.954a8.27 8.27 0 0 1-4.529-1.248c-2.188-1.464-2.188-3.851 0-5.306a8.83 8.83 0 0 1 9.049 0",
  "data-name": "Path 5522"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 5187"
}))));
export { SvgEditFollow as ReactComponent };
export default __webpack_public_path__ + "static/media/edit_follow.0540e98b899793984febfd61c0ec5c14.svg";